export default function WeddingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative h-96 bg-gradient-to-br from-rose-400 to-pink-500 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&h=600&fit=crop"
          alt="Wedding celebration"
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-40"
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
          <h1 className="text-5xl font-bold text-white mb-4">Wedding Party Gift Exchange</h1>
          <p className="text-xl text-white max-w-2xl">
            Honor your wedding party with a thoughtful exchange that celebrates your special day
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Wedding Party Appreciation</h2>
          <p className="text-lg text-gray-600 mb-6">
            Your wedding party has invested time, money, and energy into making your day perfect. A coordinated gift
            exchange is a beautiful way to show appreciation while creating lasting memories among your closest friends
            and family.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">Perfect for</h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>• Bridal party gifts from couple</li>
                <li>• Groomsmen/bridesmaids exchanges</li>
                <li>• Rehearsal dinner activities</li>
                <li>• Bachelor/bachelorette parties</li>
                <li>• Wedding party appreciation events</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">Typical budget range</h3>
              <p className="text-gray-600 text-sm mb-3">
                Wedding party gifts typically range from $50 to $150 per person, reflecting the significant commitment
                your party members have made to your celebration.
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">Organizing Your Wedding Exchange</h3>
          <div className="space-y-4 mb-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-rose-500 text-white rounded-full flex items-center justify-center font-bold mr-4">
                1
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Decide on the structure</h4>
                <p className="text-gray-600 text-sm">
                  Common approaches include: bride and groom giving gifts to their respective parties, the entire wedding
                  party drawing names for each other, or a combination where couples give gifts plus party members exchange
                  among themselves.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-rose-500 text-white rounded-full flex items-center justify-center font-bold mr-4">
                2
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Set appropriate timing</h4>
                <p className="text-gray-600 text-sm">
                  Present gifts during the rehearsal dinner, at a dedicated brunch, or as a surprise during the reception.
                  Avoid the actual ceremony or key wedding day moments that should focus on the couple.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-rose-500 text-white rounded-full flex items-center justify-center font-bold mr-4">
                3
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Consider personalization</h4>
                <p className="text-gray-600 text-sm">
                  Wedding gifts work best when personalized to each recipient. Engraved items, monogrammed accessories,
                  or custom pieces that reflect inside jokes or shared memories make the gifts more meaningful.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-rose-500 text-white rounded-full flex items-center justify-center font-bold mr-4">
                4
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Include heartfelt notes</h4>
                <p className="text-gray-600 text-sm">
                  Accompany each gift with a personal note expressing gratitude for specific ways that person contributed
                  to your wedding journey. These notes often become cherished keepsakes.
                </p>
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">Popular Wedding Party Gift Ideas</h3>
          <div className="bg-rose-50 border border-rose-200 rounded-lg p-6 mb-8">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">For Bridesmaids</h4>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li>• Personalized jewelry or accessories</li>
                  <li>• Spa day or beauty treatment vouchers</li>
                  <li>• Custom robes or getting-ready outfits</li>
                  <li>• Designer handbags or clutches</li>
                  <li>• Matching necklaces or bracelets</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">For Groomsmen</h4>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li>• Engraved watches or cufflinks</li>
                  <li>• Premium spirits or cigar sets</li>
                  <li>• Tech accessories or gadgets</li>
                  <li>• Golf outing or sports tickets</li>
                  <li>• Custom leather goods or wallets</li>
                </ul>
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">Thoughtful Exchange Guidelines</h3>
          <div className="border-l-4 border-rose-500 pl-6 py-4 mb-8">
            <ul className="space-y-2 text-gray-600">
              <li>• Budget consistently across all party members to avoid hurt feelings</li>
              <li>• Choose gifts people will actually use beyond the wedding day</li>
              <li>• Avoid generic "bridesmaid kit" items unless highly personalized</li>
              <li>• Consider practical items that help with wedding day logistics</li>
              <li>• For destination weddings, factor in travel costs when setting budgets</li>
              <li>• Include parents and other key helpers in your gift planning</li>
            </ul>
          </div>

          <div className="bg-rose-50 border border-rose-200 rounded-lg p-6 mb-8">
            <h4 className="font-semibold text-rose-900 mb-2">Budget-Friendly Alternative</h4>
            <p className="text-rose-800 text-sm">
              If wedding expenses are tight, consider a "Circle of Love" exchange where wedding party members draw names
              to gift each other. This reduces the financial burden on the couple while maintaining the spirit of
              celebration and gratitude.
            </p>
          </div>

          <div className="text-center">
            <a
              href="/create"
              className="inline-block px-8 py-4 bg-rose-500 text-white text-lg font-semibold rounded-lg hover:bg-rose-600 transition-colors"
            >
              Plan Your Wedding Exchange
            </a>
            <p className="text-sm text-gray-500 mt-3">No registration required • Free to use</p>
          </div>
        </div>

        <div className="bg-gray-100 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-3">Related Resources</h3>
          <div className="flex flex-wrap gap-3">
            <a href="/events/birthday" className="text-sm text-gray-700 hover:text-rose-600">
              Birthday Exchanges →
            </a>
            <a href="/blog" className="text-sm text-gray-700 hover:text-rose-600">
              Gift Ideas Blog →
            </a>
            <a href="/faq" className="text-sm text-gray-700 hover:text-rose-600">
              FAQ →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
